import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-tasks-comments-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './tasks-comments-page.component.html',
  styleUrl: './tasks-comments-page.component.css'
})
export class TasksCommentsPageComponent {

}
